<template>
  <div class="home">
    <Logo id="logo"></Logo>
    <Categorie id="categorie"> </Categorie>
    <Message id="message" class="fixed-bottom"></Message>
  </div>
</template>

<script>
// @ is an alias to /src
import Logo from "@/components/Logo.vue";
import Categorie from "@/components/Categorie.vue";
import Message from "@/components/Message.vue";
export default {
  name: "home",
  components: {
    Logo,
    Categorie,
    Message
  }
};
</script>

<style>
.btn {
  border-radius: 0.75rem;
}

body {
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  background-image: url("../assets/Bg.jpg");
  background-size: cover;
}

#categorie {
  height: 78vh;
  min-height: 78vh;
  max-height: 78vh;
  overflow-x: hidden;
  overflow-y: scroll;
  white-space: nowrap;
}

#message {
  height: 7vh;
  min-height: 7vh;
  max-height: 7vh;
}

.modalSize {
  height: 90%;
  width: 90vw !important;
}

.modalPdf {
  height: 100%;
  width: 100%;
}
.modal-body {
  height: 100%;
}

.btn_repertoire {
  width: 3.5rem;
  height: 3.5rem;
  /* Centrer et aligner image dans button */
  display: flex !important;
  justify-content: space-around !important;
  align-items: center !important;
}

.span_repertoire {
  height: 1rem;
  margin-top: 0.5rem;
  font-size: 0.75em;
}
.imageSize {
  max-height: 5rem;
}
</style>
